/* rc-featured-chassis — slow auto cross-fade between up to 3 slides.
   Pause on hover, dots to jump, pause when tab hidden. Idempotent per stage. Defer. */
(function () {
  function initOne(root) {
    if (root.__rcFcInit) return;
    root.__rcFcInit = true;
    var slides = root.querySelectorAll('[data-rc-fc-slide]');
    var dots = root.querySelectorAll('[data-rc-fc-dot]');
    if (slides.length < 2) return;

    var i = 0;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
    }
    function play() { stop(); timer = setInterval(function () { show(i + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-rc-fc-dot]');
      if (d) { show(parseInt(d.getAttribute('data-rc-fc-dot'), 10)); play(); }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });

    play();
  }

  function init() { document.querySelectorAll('[data-rc-featured]').forEach(initOne); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
